import {
  WITHDRAWAL,
  WITHDRAWAL_FAILED,
  WITHDRAWAL_SUCCEED,
  FETCH_WITHDRAWAL_HISTORY,
  FETCH_WITHDRAWAL_HISTORY_FAILED,
  FETCH_WITHDRAWAL_HISTORY_SUCCEED,
  FETCH_USER_VOLUME_24H,
  FETCH_USER_VOLUME_24H_SUCCEED,
  FETCH_USER_VOLUME_24H_FAILED,
  FETCH_USER_TRANS_HISTORY,
  FETCH_USER_TRANS_HISTORY_SUCCEED,
  FETCH_USER_TRANS_HISTORY_FAILED,
  FETCH_TRANS_HISTORY,
  FETCH_TRANS_HISTORY_SUCCEED,
  FETCH_TRANS_HISTORY_FAILED,
  FETCH_TRANS_ERROR,
  FETCH_TRANS_ERROR_SUCCEED,
  FETCH_TRANS_ERROR_FAILED,
  SEARCH_TRANS_ERROR,
  SEARCH_TRANS_ERROR_SUCCEED,
  SEARCH_TRANS_ERROR_FAILED,
  FETCH_TRANS_ERROR_FILTER,
  FETCH_TRANS_ERROR_FILTER_FAILED,
  FETCH_TRANS_ERROR_FILTER_SUCCEED,
  SEARCH_TRANSACTION_BY_ID,
  SEARCH_TRANSACTION_BY_ID_SUCCEED,
  SEARCH_TRANSACTION_BY_ID_FAILED,
  VERIFY_TRANSACTION,
  VERIFY_TRANSACTION_SUCCEED,
  VERIFY_TRANSACTION_FAILED,
  ACCEPT_TRANSACTION,
  ACCEPT_TRANSACTION_SUCCEED,
  ACCEPT_TRANSACTION_FAILED,
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_SUCCEED,
  DELETE_TRANSACTION_FAILED,
  FETCH_TRANS_FILTER_HISTORY,
  FETCH_TRANS_FILTER_HISTORY_SUCCEED,
  FETCH_TRANS_FILTER_HISTORY_FAILED,
  FETCH_VERIFY_HISTORY,
  FETCH_VERIFY_HISTORY_SUCCEED,
  FETCH_VERIFY_HISTORY_FAILED,
} from './action_types';

export default {
  onWithdrawal: (data, callback) => ({
    type: WITHDRAWAL,
    params: {
      data,
    },
    callback,
  }),
  onWithdrawalFailed: (err) => ({
    type: WITHDRAWAL_FAILED,
    err,
  }),
  onWithdrawalSucceed: (data) => ({
    type: WITHDRAWAL_SUCCEED,
    params: {
      data,
    },
  }),
  onFetchTransactionHistory: (data) => ({
    type: FETCH_WITHDRAWAL_HISTORY,
    params: {
      data,
    },
  }),
  onFetchTransactionHistorySucceed: (data, totalCount) => ({
    type: FETCH_WITHDRAWAL_HISTORY_SUCCEED,
    data,
    totalCount,
  }),
  onFetchTransactionHistoryFailed: (err) => ({
    type: FETCH_WITHDRAWAL_HISTORY_FAILED,
    err,
  }),

  fetchUserVolume24hAction: (params, callback) => ({
    type: FETCH_USER_VOLUME_24H,
    params,
    callback,
  }),

  onFetchTransactionFilterHistory: (params, callback) => ({
    type: FETCH_TRANS_FILTER_HISTORY,
    params,
    callback,
  }),

  onFetchTransactionFilterHistorySucceed: (data, totalCount) => ({
    type: FETCH_TRANS_FILTER_HISTORY_SUCCEED,
    data,
    totalCount,
  }),

  onFetchTransactionFilterHistoryFailed: (err) => ({
    type: FETCH_TRANS_FILTER_HISTORY_FAILED,
    err,
  }),

  fetchUserVolume24hActionSucceed: (data) => ({
    type: FETCH_USER_VOLUME_24H_SUCCEED,
    data,
  }),
  fetchUserVolume24hActionFailed: (err) => ({
    type: FETCH_USER_VOLUME_24H_FAILED,
    err,
  }),

  // fetchUserTransHistoryActionSucceed: (data) => ({
  //   type: FETCH_ADMIN_WITHDRAWAL_HISTORY_SUCCEED,
  //   data,
  // }),
  // fetchUserTransHistoryActionFailed: (err) => ({
  //   type: FETCH_ADMIN_WITHDRAWAL_HISTORY_FAILED,
  //   err,
  // }),
  fetchUserTransHistoryAction: (params, callback) => ({
    type: FETCH_USER_TRANS_HISTORY,
    params,
    callback,
  }),

  fetchUserTransHistoryActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_USER_TRANS_HISTORY_SUCCEED,
    data,
    callback,
  }),

  fetchUserTransHistoryActionFailed: (err) => ({
    type: FETCH_USER_TRANS_HISTORY_FAILED,
    err,
  }),

  fetchTransHistoryAction: (params, callback) => ({
    type: FETCH_TRANS_HISTORY,
    params,
    callback,
  }),

  fetchTransHistoryActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_TRANS_HISTORY_SUCCEED,
    data,
    callback,
  }),

  fetchTransHistoryActionFailed: (err) => ({
    type: FETCH_TRANS_HISTORY_FAILED,
    err,
  }),
  verifyTransaction: (data, callback) => ({
    type: VERIFY_TRANSACTION,
    data,
    callback,
  }),
  verifyTransactionSucceed: (data) => ({
    type: VERIFY_TRANSACTION_SUCCEED,
    data,
  }),
  verifyTransactionFailed: (err) => ({
    type: VERIFY_TRANSACTION_FAILED,
    err,
  }),

  acceptTransaction: (data, callback) => ({
    type: ACCEPT_TRANSACTION,
    data,
    callback,
  }),
  acceptTransactionSucceed: (data) => ({
    type: ACCEPT_TRANSACTION_SUCCEED,
    data,
  }),
  acceptTransactionFailed: (err) => ({
    type: ACCEPT_TRANSACTION_FAILED,
    err,
  }),

  deleteTransaction: (params, callback) => ({
    type: DELETE_TRANSACTION,
    params,
    callback,
  }),
  deleteTransactionSucceed: (data) => ({
    type: DELETE_TRANSACTION_SUCCEED,
    data,
  }),
  deleteTransactionFailed: (err) => ({
    type: DELETE_TRANSACTION_FAILED,
    err,
  }),

  fetchTransErrorAction: (params, callback) => ({
    type: FETCH_TRANS_ERROR,
    params,
    callback,
  }),

  fetchTransErrorActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_TRANS_ERROR_SUCCEED,
    data,
    callback,
  }),

  fetchTransErrorActionFailed: (err) => ({
    type: FETCH_TRANS_ERROR_FAILED,
    err,
  }),

  searchTransErrorAction: (params, callback) => ({
    type: SEARCH_TRANS_ERROR,
    params,
    callback,
  }),

  searchTransErrorActionSucceed: (data, totalCount, callback) => ({
    type: SEARCH_TRANS_ERROR_SUCCEED,
    data,
    callback,
  }),

  searchTransErrorActionFailed: (err) => ({
    type: SEARCH_TRANS_ERROR_FAILED,
    err,
  }),

  fetchTransErrorFilterAction: (params, callback) => ({
    type: FETCH_TRANS_ERROR_FILTER,
    params,
    callback,
  }),

  fetchTransErrorFilterActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_TRANS_ERROR_FILTER_SUCCEED,
    data,
    callback,
  }),

  fetchTransErrorFilterActionFailed: (err) => ({
    type: FETCH_TRANS_ERROR_FILTER_FAILED,
    err,
  }),

  searchTransByIDAction: (params, callback) => ({
    type: SEARCH_TRANSACTION_BY_ID,
    params,
    callback,
  }),

  searchTransByIDActionSucceed: (data) => ({
    type: SEARCH_TRANSACTION_BY_ID_SUCCEED,
    data,
  }),

  searchTransByIDActionFailed: (err) => ({
    type: SEARCH_TRANSACTION_BY_ID_FAILED,
    err,
  }),

  fetchVerifyHistory: (params, callback) => ({
    type: FETCH_VERIFY_HISTORY,
    params,
    callback,
  }),
  fetchVerifyHistorySucceed: (data) => ({
    type: FETCH_VERIFY_HISTORY_SUCCEED,
    data,
  }),
  fetchVerifyHistoryFailed: (err) => ({
    type: FETCH_VERIFY_HISTORY_FAILED,
    err,
  }),
};
